import Section from '../../enums/Sections';
import CollectionOptionsSectionWrapper from '../../sections/CollectionOptionsSection/CollectionOptionsSectionWrapper';
import ContactSectionWrapper from '../../sections/ContactSection/ContactSectionWrapper';
import DeliveryOptionSectionWrapper from '../../sections/DeliveryOptionSection/DeliveryOptionSectionWrapper';
import PaymentOptionSectionWrapper from '../../sections/PaymentOptionsSection/PaymentOptionSectionWrapper/PaymentOptionSectionWrapper';
import DeliveryAddressSectionWrapper from '../../v2/components/delivery-address-section/DeliveryAddressSectionWrapper/DeliveryAddressSectionWrapper';

export default {
  [Section.ADDRESS]: DeliveryAddressSectionWrapper,
  [Section.DELIVERY]: DeliveryOptionSectionWrapper,
  [Section.PAYMENT]: PaymentOptionSectionWrapper,
  [Section.CONTACT]: ContactSectionWrapper,
  [Section.COLLECTION]: CollectionOptionsSectionWrapper,
};
